import { render, staticRenderFns } from "./nonConformityDetail.vue?vue&type=template&id=ff1a3b40&scoped=true&"
import script from "./nonConformityDetail.vue?vue&type=script&lang=js&"
export * from "./nonConformityDetail.vue?vue&type=script&lang=js&"
import style0 from "./nonConformityDetail.vue?vue&type=style&index=0&id=ff1a3b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1a3b40",
  null
  
)

export default component.exports